const getPricipalServices = (principalServicesArray) => {
    const principalServices = principalServicesArray.filter((principalService) => principalService.peso !== null);
    principalServices.sort((a, b) => a.peso - b.peso);

    return principalServices.slice(0, 3);
}
export default getPricipalServices